/**
 * This function returns an object with properties that are on the hash, but are not received by context
 * @param hash
 * @param contextParams
 * @returns
 */

import { ParameterProps } from "../types"

 export const getHashParametersFiltered = (hash: string, contextParams: any): { [key: string]: string } => {
    const paramsKeys = Object.keys(contextParams)
    let regexp = /\?(.*)/
    return hash
        .substr(1)
        .split('&')
        .reduce(function (res, item, idx) {
            const parts = item.split('=')
            if (idx === 0 && regexp.exec(parts[0]).length >= 2 && regexp.exec(parts[0])[1] !== '')
                parts[0] = regexp.exec(parts[0])[1]

            if (paramsKeys.indexOf(parts[0]) === -1) res[parts[0]] = parts[1]
            return res
        }, {})
}


/**
 * This function parses a string into an array of parameters
 * @param {string} message - a string, that can be converted to an object, with the property 'plugin-asset-parameters', 
 * which contains an array of parameters
 * @returns - an array of parameters
 */

export const parseMessage = (message: string) => {
    let parameters = []
    try {
        parameters = JSON.parse(message)['plugin-run-parameters']
    } catch {
        console.error('Error parsing parameters')
    }
    return parameters
}

/**
 * Dispatch RunParameters update js-event
 * @param {ParameterProps[]} parameters
 */

export const dispatchParametersUpdatedEvent = (parameters: ParameterProps[]) => {
    const RUN_PARAMETERS_CHANGE_EVENT_KEY = 'run-parameters-change'

    const map = {}
    parameters.forEach(p => { map[p.key] = p })

    const event = new CustomEvent(RUN_PARAMETERS_CHANGE_EVENT_KEY, {
        detail: {...map}
    })

    console.log(`${RUN_PARAMETERS_CHANGE_EVENT_KEY} js-event sent`, map)
    document.dispatchEvent(event)
}
